import React from 'react';
import styled from 'styled-components';

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
`;

const IconWrapper = styled.div`
  margin-bottom: 2rem;
`;

const ErrorTitle = styled.h1`
  font-size: 2rem;
  font-weight: 600;
  color: #151616;
  margin: 0 0 1rem 0;
`;

const ErrorMessage = styled.p`
  font-size: 1.125rem;
  color: #5a5a6b;
  margin: 0 0 2rem 0;
  text-align: center;
  max-width: 500px;
`;

const RetryButton = styled.button`
  background: linear-gradient(135deg, #7c8ff5 0%, #8b9dfc 100%);
  color: white;
  border: none;
  padding: 1rem 3rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 20px;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(124, 143, 245, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(124, 143, 245, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;
const ErrorIcon = () => (
  <svg
    width="200"
    height="200"
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Background Circle with Gradient */}
    <defs>
      <linearGradient id="circleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#c4b5fd" />
        <stop offset="100%" stopColor="#ddd6fe" />
      </linearGradient>
    </defs>
    <circle cx="100" cy="100" r="100" fill="url(#circleGradient)" />

    {/* Question Mark */}
    <text x="145" y="65" fill="white" fontSize="48" fontWeight="bold" opacity="0.9">
      ?
    </text>

    {/* Person Body */}
    <rect x="70" y="125" width="60" height="45" rx="10" fill="#5b7cee" />

    {/* Person Head */}
    <circle cx="100" cy="100" r="25" fill="#fbbf93" />

    {/* Hair - Left Side */}
    <ellipse cx="90" cy="80" rx="15" ry="17" fill="#2c3e50" />

    {/* Hair - Right Side */}
    <path d="M 100 75 Q 115 75 120 85 Q 122 95 115 100 L 100 95 Z" fill="#2c3e50" />

    {/* Left Eye */}
    <ellipse cx="92" cy="97" rx="4" ry="5" fill="#34495e" />

    {/* Right Eye */}
    <ellipse cx="108" cy="97" rx="4" ry="5" fill="#34495e" />

    {/* Mouth - Sad */}
    <path
      d="M 90 110 Q 100 105 110 110"
      stroke="#34495e"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
    />

    {/* Eyebrows - Concerned */}
    <path
      d="M 87 90 Q 92 88 97 89"
      stroke="#34495e"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
    />
    <path
      d="M 103 89 Q 108 88 113 90"
      stroke="#34495e"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
    />
  </svg>
);

// Reusable Error State Component
const ErrorState = ({
  title = 'Your report is being prepared!',
  message = 'This may take a little longer. Please hang tight while we finish generating it.',
  buttonText = 'Try Again',
  onRetry,
  icon = <ErrorIcon />,
}) => {
  return (
    <ErrorContainer>
      <IconWrapper>{icon}</IconWrapper>

      <ErrorTitle>{title}</ErrorTitle>
      <ErrorMessage>{message}</ErrorMessage>
      <RetryButton onClick={onRetry}>{buttonText}</RetryButton>
    </ErrorContainer>
  );
};

export default ErrorState;
